import { reactive } from 'vue'
class HeaderFooterHeight{
    //ヘッダーの高さ（header.scss）の定義のメディアクエリと合わせる（padding等を含む）
    private widths = [769, 768, 576, 480, 340];
    private events = [] as MediaQueryList[];
    private heights = [100, 90, 80, 80, 80,];//480行目でforkstyleのロゴが改行されるので高さが増える
    private currentIndex = 0;


    getHeight(){
        return this.heights[this.currentIndex];
    }

    regesterEvent(){
        this.widths.forEach((px, index)=>{
            if(index === 0){
                this.events[index] = window.matchMedia("(min-width: " + px + "px)");
            }else{
                this.events[index] = window.matchMedia("(max-width: " + px + "px)");
            }
            this.events[index].addEventListener("change",()=>this.setMainHeight());
        });
        this.setMainHeight();
    }

    private setMainHeight(){
        this.widths.forEach((_px, index) =>{
            if(this.events[index].matches){
                this.currentIndex = index;
            }
        })
    }
}


export default reactive(new HeaderFooterHeight());